import _ from 'lodash';
import { createContext, useContext } from 'react';
const defaultEmbedContextOptions = {
    isEmbedded: false,
    isPoweredFooterHidden: false,
    useEmbedEventSubscription: () => {
    },
    dispatchEmbedEvent: () => Promise.resolve(),
    embedParams: {},
    updateEmbedParams: _.noop,
    runtimeFilterParams: [],
    updateRuntimeFilterParams: _.noop,
    embedParameterParams: [],
    updateEmbedParameterParams: _.noop,
    onLayoutChange: _.noop,
    hiddenHomeLeftNavItems: [],
    hiddenHomepageModules: [],
    reorderedHomepageModules: [],
};
export const EmbedContext = createContext(defaultEmbedContextOptions);
export const useEmbedContext = () => useContext(EmbedContext);
//# sourceMappingURL=embed-context.js.map